
import {map} from 'rxjs/operators';
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { SignInRequestVM, AuthResponseVM, WhoAmIVM, ChangePasswordRequestVM, ForgottenPasswordRequestVM, ResetPasswordRequestVM } from "../models";
import { BaseService } from "./base.service";

@Injectable()
export class AuthService extends BaseService {

    constructor(private http: HttpClient) {
        super();
    }

    public whoAmI(): Observable<WhoAmIVM> {
        return this.http.get('/api/auth/whoami', this.getHttpOptions(true)).pipe(
            map(resp => resp as WhoAmIVM));
    }

    public forgottenPassword(request: ForgottenPasswordRequestVM): Observable<ForgottenPasswordRequestVM> {
        return this.http.post('/api/auth/forgotpassword', request, this.getHttpOptions(false)).pipe(
            map(resp => resp as ForgottenPasswordRequestVM));
    }

    public changePassword(request: ChangePasswordRequestVM): Observable<boolean> {
        return this.http.post('/api/auth/changepassword', request, this.getHttpOptions(true)).pipe(
            map(resp => !!resp));
    }

    public login(loginRequest: SignInRequestVM): Observable<AuthResponseVM> {
        return this.http.post('/api/auth/signin', loginRequest, this.getHttpOptions(false)).pipe(
            map(resp => resp as AuthResponseVM));
    }

    public validateUserToken(): Observable<boolean> {      
        return this.http.post('/api/auth/isuserauth', null, this.getHttpOptions(true)).pipe(
            map(resp => !!resp));
    }

    public verifyResetPwdToken(token: string): Observable<boolean> {
        return this.http.post('/api/auth/verifyresetpwdtoken', JSON.stringify(token), this.getHttpOptions(false)).pipe(
            map(resp => !!resp));
    }

    public unlockAccount(token: string): Observable<boolean> {
        return this.http.post('/api/auth/unlockaccount', JSON.stringify(token), this.getHttpOptions(false)).pipe(
            map(resp => !!resp));
    }

    public resetPassword(request: ResetPasswordRequestVM): Observable<boolean> {
        return this.http.post('/api/auth/resetpassword', request, this.getHttpOptions(false)).pipe(
            map(resp => !!resp));
    }

}